var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDanger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 124,
    viewBox: "0 0 138 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.2336 11.25C65.9115 6.59243 72.624 6.59243 75.3019 11.25L100.188 54.53L125.075 97.81C127.753 102.468 124.396 108.308 119.041 108.308H69.2678H19.4592C14.1035 108.308 10.7472 102.468 13.4251 97.81L38.3115 54.53L63.2336 11.25Z",
    fill: "#FF4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9229 94.2236C75.4315 91.079 73.3034 88.116 70.1695 87.6057C67.0356 87.0953 64.0828 89.2308 63.5742 92.3755C63.0656 95.5201 65.1938 98.4831 68.3277 98.9934C71.4615 99.5038 74.4143 97.3683 74.9229 94.2236Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9443 36.1504H61.5554C61.5554 57.6471 64.9474 82.4757 64.9474 82.4757H73.5166C73.5523 82.4399 76.9443 57.6112 76.9443 36.1504Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDanger);
export default __webpack_public_path__ + "static/media/danger.e37c97d7c16b73cfe49b3ff01cc2ef7f.svg";
export { ForwardRef as ReactComponent };